export class ARPaymentTransferAccountRawDto {
    communityId: number;
    customerCode: string;
    description: string;
}
